import { russianDefaultPaymentCards } from "app/constants/CurrencyConstants";

export const reducer: typeof window.kinosite.reducer = {
	cinema: {
		payment: {
			active: true,
			card: russianDefaultPaymentCards,
		},
		selectButton: {
			options: [
				{
					value: '//mir.orenkino.ru',
					title: 'Мир, Орск',
				},
				{
					value: '//sokol.orenkino.ru',
					title: 'Сокол, Оренбург',
				},
				{
					value: '//junost.orenkino.ru',
					title: 'Юность, Абдулино',
				},
				{
					value: '//rodina.orenkino.ru',
					title: 'Родина, Бугуруслан',
				},
				{
					value: '//ural.orenkino.ru',
					title: 'Урал, Медногорск',
				},
				{
					value: '//kolos.orenkino.ru',
					title: 'Колос, Новосергиевка',
				},
			],
			selectedOptionValue: '//mir.orenkino.ru',
		},
		soonPageIsEnabled: false,
	},
	feedback: true,
};
